import {useEffect} from 'react'

export const GoogleTagManager = (props) => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'})

    const firstScript = document.getElementsByTagName('script')[0]
    let gtmScript = document.createElement('script')
    gtmScript.async = true
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${props.gtmId}&gtm_auth=${props.gtmAuth}&gtm_preview=${props.gtmPreview}&gtm_cookies_win=x`
    firstScript.parentNode.insertBefore(gtmScript, firstScript)
  }, [])

  return null
}
